import { render, staticRenderFns } from "./pauseModal.vue?vue&type=template&id=49d4dbc1&scoped=true"
import script from "./pauseModal.vue?vue&type=script&lang=js"
export * from "./pauseModal.vue?vue&type=script&lang=js"
import style0 from "./pauseModal.vue?vue&type=style&index=0&id=49d4dbc1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4dbc1",
  null
  
)

export default component.exports